import { HandleType } from '@/enums/handle-type.enum';
import type { FlowView } from '@/components/Recipe/Views/FlowView';

/**
 * Whether a node produces video output, resolved from its output handle types — the same resolution the
 * canvas uses to render outputs. Works for predefined and imported/wildcard models alike (unlike a menu
 * lookup, which has no entry for imported models).
 */
export const isVideoOutputNode = (nodeId: string, flowView: FlowView): boolean =>
  flowView.getOutputIds(nodeId).some((outputId) => flowView.nodeOutputType(nodeId, outputId) === HandleType.Video);
